export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  GROWTH_LOCATION_PAGE_GOOGLE_MAPS_REDIRECT_BOOKING = "GROWTH_LOCATION_PAGE_GOOGLE_MAPS_REDIRECT_BOOKING",
}
